




























































import {Component, Vue} from 'vue-property-decorator';
import PaginateButtons from '@/layouts/gripper/components/PaginateButtons.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';
import {Pipeline} from '@/types/gripper';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import {PipelinesVariables} from '@/types/intrador';

@Component({
  components: {
    HotkeyListener,
    PaginateButtons,
    HotkeyLegend,
  },
  metaInfo: {
    title: 'JobDashboard',
  },
})
export default class Dashboard extends Vue {

  private pipelines: Pipeline[] = [];

  private selectedRowID: number | null = null;
  private page: number = 1;
  private limit: number = 15;
  private totalPages: number = 0;

  private search = '';
  private searchInput = '';

  private headers = [
    {
      text: 'ID',
      align: 'start',
      filterable: true,
      sortable: false,
      value: 'id',
    },
    {
      text: 'Name',
      value: 'name',
      filterable: true,
      sortable: false,
    },
  ];

  private items: any[] = [];

  private resolveData(data: any) {
    this.items = [];
    this.totalPages = data.pipelines.paginatorInfo.lastPage;
    this.pipelines = data.pipelines.data;

    this.pipelines.forEach((pipeline: any) => {
      this.items.push({
        id: pipeline.id,
        name: pipeline.name,
      });
    });
  }

  private async pageChange(newPage: number) {
    this.page = newPage;
    this.pipelines = [];
    this.refetch();
  }

  private refetch() {
    if (this.queryResult) {
      const result = this.queryResult.fetchMore({
        variables: this.queryVariables,
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) {
            return prev;
          }
          return {
            ...fetchMoreResult,
          };
        },
      });
    }
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  get queryVariables() {
    return {
      whereSearch: this.search,
      page: this.page,
      limit: this.limit,
    };
  }

  private clickRow(pipeline: any) {
    this.$router.push({
      name: 'pipeline',
      params: {
        pipelineID: pipeline.id,
      },
      query: {},
    });
  }

}
